"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _onboardingStatus = require("@/utils/onboardingStatus");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'TableListLivenesPerson',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actionOpen: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: {
    tableRows: function tableRows() {
      return this.list.map(function (item) {
        var _item$document, _item$document2;
        var document = (_item$document = item.document) !== null && _item$document !== void 0 && _item$document.includes('*') ? item.document : (_item$document2 = item.document) === null || _item$document2 === void 0 ? void 0 : _item$document2.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        return _objectSpread(_objectSpread({}, item), {}, {
          hiveId: item.hiveId || '-',
          businessUnit: item.businessUnit || '-',
          document: document
        });
      });
    }
  },
  methods: {
    action: function action(item) {
      this.actionOpen(item);
    },
    statusTagClass: function statusTagClass(status) {
      var variant = (0, _onboardingStatus.getOnboardingStatusVariant)(status);
      return {
        'is-warning is-light': variant === 'warning',
        'is-success is-light': variant === 'success',
        'is-danger is-light': variant === 'danger',
        'is-info is-light': variant === 'info'
      };
    }
  }
};